<template>
  <!--
    作者：kmdshop
    时间：2020-06-04
    描述：插件中心-积分商城-商品列表
  -->
  <div class="user" v-loading="loading">
    <el-form size="small" :model="form" ref="form">
      



      <el-form-item :label-width="formLabelWidth" label="获得分红的等级">
        <el-table size="small" :data="profiteer" border>
          <el-table-column prop="name" label="等级"></el-table-column>
          <el-table-column prop="is_sel" label="是否选择">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.is_sel"></el-checkbox>
            </template>
          </el-table-column>

        </el-table>
      </el-form-item>


      <el-form-item :label-width="formLabelWidth" label="分红条件">
        <el-input v-model="form.bonus_people" type="number" 
           style="width: 160px;margin-bottom: 10px;" placeholder="满多少人"></el-input>人
        <el-table size="small" :data="bonus" border>
          <el-table-column prop="name" label="等级"></el-table-column>
          <el-table-column prop="is_sel" label="是否选择">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.is_sel"></el-checkbox>
            </template>
          </el-table-column>

        </el-table>
      
      </el-form-item>

      <el-form-item :label-width="formLabelWidth" label="团队业绩直推">
    
          <el-input v-model="form.rebate" type="number"
           style="width: 160px;"></el-input>%
      </el-form-item>
      <el-form-item :label-width="formLabelWidth" label="团队业绩间推">
    
          <el-input v-model="form.jian_rebate" type="number"
          style="width: 160px;"></el-input>%
          <div>间推基于直推计算</div>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer" style="margin: auto;">
      <el-button type="primary" @click="addGrade()">确 定</el-button>
    </div>


  </div>
</template>
<script>
import TeamApi from '@/api/team.js';
  import {deepClone} from '@/utils/base.js';
export default {

  data() {
    return {
      /*是否加载完成*/
      loading: true,

        gradeList:[],
        form:{
          jian_rebate:0,
          rebate:0
        },
        formLabelWidth: '120px',
        profiteer:[],
        bonus:[]
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
  

      /*添加等级*/
      addGrade() {
        let self = this;
        let params = this.form;
        params.profiteer =JSON.stringify(this.profiteer);
        params.bonus =JSON.stringify(this.bonus);
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            TeamApi.settingIndex(params, true).then(data => {
                self.submit_loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.submit_loading = false;
              });
          }
        });
      },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      TeamApi.index(Params, true)
        .then(res => {
          self.profiteer = res.data.profiteer
          self.bonus = res.data.bonus
          self.form =  res.data.list
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

  }
};
</script>

<style>
.point-list .el-input-number--mini {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/team/index/index.vue